<template>
    <div class="toolbar-container">
        <el-button ref="swtichToolbarPanel" style="height:auto!important" :icon="[isOpen?'el-icon-search1':'el-icon-search']" :title='title' :class="['btn',{'btnBlue':isOpen}]" @click="setToolBarPanel">工具栏<img src="@/assets/images/icon16.png" alt="" :class="[isOpen?'upArrow':'downArrow']"></el-button>
        <ul class="tool-bar-btn-back" v-show="isOpen">
            <li class="tool-bar-btn-li" v-for= "(item,index) in menuArray"  :key="item.id"  >
                <div @click.stop="showTool(index)">
                    <a href="#"> 
                    <img :src="index === flg && flag===true ? item.iconSeleted:item.icon"/>
                    {{item.text}}
                    </a>
                </div>

                <ul class='sub-tool-bar' v-show="index === flg ? isShow : false"  :style="item.styles"  :id="item.id">
                    <li v-for="(list) in item.cont" :key="list.id">
                        <img :src='list.icon' /><i :id="list.id" @click="toolClick(item.id,list.id)">{{list.text}}</i>
                    </li>
                </ul>
            </li>
        </ul>
        <div id="bufferPanel" class="bufferPanel" v-show="showBufferPanel">
            <div class="title">缓冲区分析
                <i @click="closeBufferPanel">X</i>
            </div>
            <div class="base-div-back">
                <el-button id="point" class="bufferBtn" @click="buffer('point')">点</el-button>
                <el-button id="polyline" class="bufferBtn" @click="buffer('polyline')">线</el-button>
                <el-button id="polygon" class="bufferBtn" @click="buffer('polygon')">面</el-button>
            </div>
            <div class="base-div-back" style="text-align: left;padding-left: 15px;padding-top: 0px;">
                <i>距离:</i> 
                <el-input ref='bufferDistance' v-model="input" class="input-value"></el-input> 
                <i>km</i>
            </div>
            <div class="base-div-back">
                <el-button class="clearBtn" @click="clearBuffer">清除</el-button>
            </div>
        </div>
    </div>
</template>
<script>
//import $ from 'jquery'
import basicTool from '@/assets/mapToolImages/baseTool.png'
import basicSelected from '@/assets/mapToolImages/baseToolSelect.png'
import drawTool from '@/assets/mapToolImages/drawTool.png'
import drawToolSeleted from '@/assets/mapToolImages/drawToolSelect.png'
import analysisTool from '@/assets/mapToolImages/analyseTool.png'
import analysisSeleted from '@/assets/mapToolImages/analyseToolSelect.png'

import zoomIn from  "@/assets/mapToolImages/zoomIn.png"
import zoomOut from  "@/assets/mapToolImages/zoomOut.png"
import pan from  "@/assets/mapToolImages/pan.png"
import fullMap from  "@/assets/mapToolImages/content.png"
import switchMap from  "@/assets/mapToolImages/switch.png"
import singleRemove from  "@/assets/mapToolImages/singleRemove.png"

import point from  "@/assets/mapToolImages/point.png"
import line from  "@/assets/mapToolImages/line.png"
import polyline from  "@/assets/mapToolImages/polyline.png"
import polygon from  "@/assets/mapToolImages/polygon.png"
import circle from  "@/assets/mapToolImages/circle.png"
import ellipse from  "@/assets/mapToolImages/ellipse.png"
import rectangle from  "@/assets/mapToolImages/rectangle.png"
import triangle from  "@/assets/mapToolImages/triangle.png"
import arrow from  "@/assets/mapToolImages/arrow.png"
import edit from  "@/assets/mapToolImages/edit.png"
import clear from  "@/assets/mapToolImages/clear.png"

import distance from  "@/assets/mapToolImages/distance.png"
import area from  "@/assets/mapToolImages/area.png"

import { loadCss, loadModules } from 'esri-loader';
export default {
    data(){
        return{
            input:"1",
            title:"展开工具栏",
            isShow:false,//显示子项工具条
            flag:true,//选中切换图片
            flg:-1,//当前选中的工具类型
            isOpen:false,//是否打开工具条
            showBufferPanel:false,
            menuArray:[
                {id:"basicTool","text":"基础工具",icon:basicTool,iconSeleted:basicSelected, styles:{top:'0',right:'-120px'},
                    cont:[{id:"zoomIn",text:"拉框放大",icon:zoomIn},
                    {id:"zoomOut",text:"拉框缩小",icon:zoomOut},
                    {id:"pan",text:"漫游",icon:pan},
                    {id:"fullMap",text:"全图",icon:fullMap},
                    // {id:"switchMap",text:"底图切换",icon:switchMap},
                    {id:"singleRemove",text:"清除选择",icon:singleRemove}]
                },
                {id:"drawTool","text":"绘图工具",icon:drawTool,iconSeleted:drawToolSeleted, styles:{top:'40px',right:'-120px'},
                    cont:[{id:"Point",text:"点",icon:point},
                    {id:"Line",text:"线",icon:line},
                    {id:"Polyline",text:"折线",icon:polyline},
                    {id:"Polygon",text:"多边形",icon:polygon},
                    {id:"Circle",text:"圆形",icon:circle},
                    {id:"Ellipse",text:"椭圆",icon:ellipse},
                    {id:"rectangle",text:"矩形",icon:rectangle},
                    {id:"triangle",text:"三角形",icon:triangle},
                    {id:"arrow",text:"箭头",icon:arrow},
                    {id:"edit",text:"编辑",icon:edit},
                    {id:"clear",text:"清除",icon:clear}]
                },
                {id:"analysisTool","text":"分析工具",icon:analysisTool,iconSeleted:analysisSeleted, styles:{top:'80px',right:'-120px'},
                    cont:[{id:"distance",text:"测距",icon:distance},
                    {id:"area",text:"测面积",icon:area},
                    {id:"buffer",text:"缓冲区分析",icon:area}]
                }
            ],
            map:null,
            drawTool:null,//绘图工具
            drawGraphicsLayer:null,//绘图图层
            editTool:null,//编辑工具
            navToolbar:null,//导航工具
            markerSymbol:null,//点符号
            lineSymbol:null,//线符号
            fillSymbol:null,//面符号
            spatialReference:null,//当前地图的坐标系
            currentMapTool:null,//当前地图工具
            measureDistance:null,//测距
            measureArea:null,//测距
            bufferTool:null,//缓冲区分析
            identifyClickPoint:null,
            identifyHighlightLayer:null,
            currentBasemapType:null,
            gisConstructor: {}, //gis 构造函数
            gisModules: [
                "dojo/on",
                "dojo/_base/lang",
                "dojo/_base/event",
                "esri/toolbars/edit",
            	"esri/toolbars/draw",
                "esri/toolbars/navigation",
                "widget/MapToolbar/buffer/Buffer",
                "widget/MapToolbar/measureDistance/MeasureDistance",
                "widget/MapToolbar/measureArea/MeasureArea",
                "esri/symbols/SimpleFillSymbol",
                "esri/symbols/SimpleMarkerSymbol", 
                "esri/symbols/SimpleLineSymbol",
                "esri/Color",
                'esri/layers/GraphicsLayer',
                "esri/graphic",
            ]
        }
    },
    props:{
        propsParam:Object
    },
    created() {
        this.map = this.propsParam.map;
        this.init();
        $(window).click((evt) =>{
            this.isShow = false;
            this.flag = false;
        });
    },
    mounted(){
        
    },
    methods: {
        init(){
            // 加载css;
            loadCss('/arcgisjs/arcgis_js_api/3.26/library/3.26compact/esri/css/esri.css');
            const options = {
                url: "/arcgisjs/arcgis_js_api/3.26/library/3.26compact/init.js",
                dojoConfig:{
                    parseOnLoad: true,
                    async: true,
                    packages: [{ 
                        name: '',
                        location: ""
                    }] 
                }
            }
            // 加载模块
            loadModules(this.gisModules, options).then(this.instance).then(()=>{
                this.initToolBar();
                this.initSymbol();
                this.addGraphicsLayer();
                this.bindingEvents();
            });
        },
        instance(args) {
            // 这里处理了一下传参，构造函数全部保存到 gisConstructor 对象中，对应的函数
            // key 值为加载模块的最后一个单词
            // 注意大小写，3.x 的API感觉有点乱，API文件的开头有大写有小写，注意一定对应起来，
            // 比如 map.js 和 graphic.js 的文件名的开头就是小写的，
            for (let k in args) {
                let name = this.gisModules[k].split('/').pop();
                this.gisConstructor[name] = args[k];
            }
        },
        bindingEvents(){
            this.gisConstructor.on(this.map,"click",this.gisConstructor.lang.hitch(this,function(evt){
                this.editTool.deactivate();
                if(this.currentMapTool == "identify"){
                    let geometry = evt.mapPoint;
                    this.identifyClickPoint = geometry;
                    //this.identifyQuery(geometry);
                }
            }));
            this.drawGraphicsLayer.on("click",this.gisConstructor.lang.hitch(this,function(evt){
                this.gisConstructor.event.stop(evt);
                if(this.currentMapTool == "singleRemove"){
                    this.removeGraphic(evt.graphic);
                }
                else if(this.currentMapTool == "edit"){
                    this.editTool.activate(this.gisConstructor.edit.MOVE
                            | this.gisConstructor.edit.SCALE 
                            | this.gisConstructor.edit.ROTATE
                            | this.gisConstructor.edit.EDIT_VERTICES
                            | this.gisConstructor.edit.EDIT_TEXT, evt.graphic);
                        
                }
            }));
        },
        //初始化工具
        initToolBar(){
            if(!this.drawTool){
                this.drawTool = new this.gisConstructor.draw(this.map);
                this.drawTool.on("draw-end", this.gisConstructor.lang.hitch(this,this.drawEndHandler));
            }
            if(!this.editTool){
                this.editTool = new this.gisConstructor.edit(this.map);
            }
            if(!this.navToolbar){
                this.navToolbar = new this.gisConstructor.navigation(this.map)
            } 
            if(!this.bufferTool) {
                this.bufferTool = new this.gisConstructor.Buffer({
                    map:this.map,
                    navToolbar:this._navToolbar
                })
            }
            if (!this.measureDistance) {
                this.measureDistance = new this.gisConstructor.MeasureDistance({
                    map:this.map,
                    imgPath:this.getPathOfCssImages() + "measure/"
                });
            }
            if (!this.measureArea) {
                this.measureArea = new this.gisConstructor.MeasureArea({
                    map:this.map,
                    closeImageURL:this.getPathOfCssImages() + "measure/delete.png"
                })
            }
        },
        toolClick(itemId,listId){
            if(listId === "buffer"){//缓冲区分析
				this.showBufferPanel = true;
			}else{
                this.showBufferPanel = false;
            }

            if(itemId == "basicTool"){
                this.basicToolClick(listId)
            }else if(itemId == "drawTool"){
                this.drawToolClick(listId);
            }else if(itemId == "analysisTool"){
                this.analysesToolClick(listId);
            }
        },
        basicToolClick(id){
            //先禁用掉
			this.deactivateAllTool();
			this.setMapDefaultCursor();
            this.currentMapTool = id;
            window.currentMapTool = this.currentMapTool;
            if(id === "zoomIn"){  //拉框放大
                this.map.setMapCursor('crosshair'); 
                this.navToolbar.activate(this.gisConstructor.navigation.ZOOM_IN);
            }else if(id === "zoomOut"){  //拉框缩小
                this.map.setMapCursor('crosshair'); 
                this.navToolbar.activate(this.gisConstructor.navigation.ZOOM_OUT);
            }else if(id === "pan"){  //漫游
                this.navToolbar.activate(this.gisConstructor.navigation.PAN);
            }else if(id === "fullMap"){  //全图
                this.navToolbar.zoomToFullExtent();
            }else if(id === "switchMap"){//底图切换
                this.switchMap();
            }else if(id === "singleRemove"){  //清除选择
                
            }else if(id === "identify"){  //识别
                this.isIdentify = true;
            }
            window.isBaseTool = true;
        },
        //初始化符号
		initSymbol(){
            //点
            this.markerSymbol = new this.gisConstructor.SimpleMarkerSymbol(this.gisConstructor.SimpleMarkerSymbol.STYLE_CIRCLE, 10,
                    new this.gisConstructor.SimpleLineSymbol(this.gisConstructor.SimpleLineSymbol.STYLE_SOLID,
                            new this.gisConstructor.Color([255,0,0]), 1),
                        new this.gisConstructor.Color([0,255,0,0.25]));
            
            //线
            this.lineSymbol = new this.gisConstructor.SimpleLineSymbol(
                    this.gisConstructor.SimpleLineSymbol.STYLE_SOLID,
                    new this.gisConstructor.Color([255,0,0]), 2);
            //面
            this.fillSymbol = new this.gisConstructor.SimpleFillSymbol(
                this.gisConstructor.SimpleFillSymbol.STYLE_SOLID,
                new this.gisConstructor.SimpleLineSymbol(
                    this.gisConstructor.SimpleLineSymbol.STYLE_SOLID,
                    new this.gisConstructor.Color([255,0,0,0.35]),
                    1
                ),
                new this.gisConstructor.Color([255,0,0,0.35])
            );
        },
        addGraphicsLayer(){
            this.drawGraphicsLayer = new this.gisConstructor.GraphicsLayer({id:"drawLayer"});
            this.map.addLayer(this.drawGraphicsLayer);
            this.identifyHighlightLayer = new this.gisConstructor.GraphicsLayer({id:"identifyHighlightLayer"});
            this.map.addLayer(this.identifyHighlightLayer);
        },
        //绘图工具
        drawToolClick(id){
            this.setMapDefaultCursor();
            this.currentMapTool = id;
            window.currentMapTool = this.currentMapTool;
			//先禁用掉
			this.deactivateAllTool();
			if(id === "edit"){//编辑
				
			}else if(id === "clear"){//清除
				this.drawGraphicsLayer.clear();
			}else{//其他：点、线、面等
				this.map.setMapCursor('crosshair'); 
				let tool = id.toLowerCase();
	            this.map.disableDoubleClickZoom();
	            this.drawTool.activate(tool,{showTooltips:true});
            }
            window.isBaseTool = false;
        },
        //分析工具
		analysesToolClick(id){
            this.currentMapTool = id;
            window.currentMapTool = this.currentMapTool;
			this.map.disableDoubleClickZoom();
			//先禁用掉
			this.deactivateAllTool();
			if(id === "distance"){//测距
				this.distance();
            }else if(id === "area"){//测面

				this.area();
            }else if(id === "buffer"){//缓冲区分析
				
            }
            window.isBaseTool = false;
		},
        //绘图结束监听事件
		drawEndHandler:function(evt){
            window.currentMapTool = null;
            this.drawTool.deactivate(); 
            this.map.enableDoubleClickZoom();
            this.setMapDefaultCursor();
            var symbol;
            if (evt.geometry.type === "point" || evt.geometry.type === "multipoint") {
                symbol = this.markerSymbol;
            } else if (evt.geometry.type === "line" || evt.geometry.type === "polyline") {
                symbol = this.lineSymbol;
            }
            else {
                symbol = this.fillSymbol;
            }
            this.drawGraphicsLayer.add(new this.gisConstructor.graphic(evt.geometry, symbol)); 
        },
        //测距
		distance(){
            this.measureDistance.currentMapTool = this.currentMapTool;
            this.measureDistance.activate();
            window.currentMapTool = null;
        },
        //测面积
		area(){
            this.measureArea.activate();
            window.currentMapTool = null;
        },
        buffer(id){
            let value = this.$refs.bufferDistance.value;
            this.bufferTool.activate(id,value);
            window.currentMapTool = null;
        },
        clearBuffer(){
            this.bufferTool.clear();
        },
        closeBufferPanel(){
            this.showBufferPanel = false;
            this.bufferTool.clear();
            this.bufferTool.deactivate();
        },
        //禁用工具（绘图、编辑工具、导航工具）
		deactivateAllTool(){
			this.drawTool.deactivate();
			this.editTool.deactivate();
			this.navToolbar.deactivate();
			this.measureDistance.deactivate();
            this.measureArea.deactivate();
        },
        getPathOfCssImages(){
            var url = window.location.protocol+"//"+ window.location.host 
                +'/arcgisjs/arcgis_js_api/3.26/library/3.26compact/widget/MapToolbar/css/image/';
            return url;
        },
        setMapDefaultCursor(){
            this.map.setMapCursor("default");
        },
        //清除选中
		removeGraphic(graphic){
		    this.drawGraphicsLayer.remove(graphic);
		},
        setToolBarPanel(){
            this.isOpen = !this.isOpen;
            if(this.isOpen){
                this.title = "收起工具栏"
            }else{
                this.title = "展开工具栏"
            }
            this.isShow = false;
            this.flag = false;
            this.showBufferPanel = false;
        },
        //显示工具
        showTool(index){          
            if(index != this.flg){
                this.flg = index;
                this.isShow = true;
                this.flag = true;
            }else{
                //如果是自身，判断它是显示还是隐藏，显示就隐藏，隐藏就显示
                if(this.isShow == false){
                    this.isShow = true;
                    this.flg = index;
                    this.flag = true;
                }else{
                    this.isShow = false;
                    this.flag = false;
                }   
            }
            this.showBufferPanel = false;
        }
    }
    
}
</script>
<style lang="scss">
.upArrow{transform:rotate(180deg);transition:all .2s linear;margin-left:10px;}
.downArrow{transform:rotate(0);transition:all .2s linear;margin-left:10px;}
.toolbar-container{
    position:absolute;
    right:160px;
    top:10px;
    width: 154px;
    .sub-tool-bar{
        position:absolute;
        right: 150px;
        width:110px;
        background-color:#fff;
        padding:5px 0;
        border-radius:3px;
        box-shadow: 0 0 5px #ccc;
        li{
            text-align: left;
            height:30px;
            line-height:30px;
            list-style:none;
            margin-left: 15px; 
            cursor: pointer;
        }
        li:hover{
            color:#0096FF;
            text-decoration:underline;
        }
        img{
            margin-right:5px;
            margin-left: -7px;
            vertical-align:middle;
        }
        i{
            font-style:normal;
            font-size:14px;
        }
    }
    
    .btn{
      position: relative;
      margin-top: 20px;
      right: 0;
      padding:10px 14px;
    //   width: 120px;
      color: #526281;
      cursor: pointer;
      border-radius: 5px;
    //   background:linear-gradient(to right,#52bdff,#0084ff);
      background:#fff;
    //   border: rgb(8,166,234) 1px solid;
      .el-icon-search{
          width:13px;
        content: url('./../../assets/images/icon41.png');
        vertical-align: top;
      }
      .el-icon-search1{
        width:13px;
        content: url('./../../assets/images/icon41-1.png');
        vertical-align: top;
        }
   }
   .btnBlue{
        color:#0084ff
    }
   .tool-bar-btn-back{
       position: absolute;
       right: 20px;
       top:70px;
       height: auto;
       width: 110px;
       background:#fff;
       box-shadow:0 0 5px #ccc;
    //    background-image: url('./../../assets/mapToolImages/toolback.png');
   }
   .tool-bar-btn-li{
        list-style: none;
        padding-top:10px;
        padding-bottom: 10px;
        text-align: center;
        font-size:14px;
        img{
             vertical-align: -3px;
            width: 14px;
        }
        a{
            color:#526281
        }
   }
   .tool-bar-btn-li:hover{
       background:#e8f5fd;
       a{
           color:#0096FF
       }
   }
    .bufferPanel{
        position: absolute;
        width: 250px;
        height: 170px;
        right: 150px;
        background-color: #FFFFFF;
        border-radius: 4px;
        .title{
            position: relative;
            width: 100%;
            height: 36px;
            background-color: rgb(8,186,235);
            color: #FFFFFF;
            border-top-right-radius: 4px;
            line-height: 36px;
            padding-left: 10px;
            i{
                font-style: normal;
                font-size: 14px;
                line-height: 40px;
                position: absolute;
                right: 10px;
                cursor: pointer;
            }
        }
        .base-div-back{
            position: relative;
            width: 100%;
            height: 40px;
            text-align: center;
            padding-top: 5px;
            color: #605A66;
            i{
                font-style: normal;
                font-size: 14px;
                line-height: 40px;
            }
        }
        .bufferBtn{
            width: 65px;
            height: 30px;
            text-align: center;
            padding: 0px;
        }
        .input-value{
            width: 100px;
        }
        .el-input__inner{
            height: 30px;
        }

        .clearBtn{
            width: 220px;
            height: 30px;
            text-align: center;
            padding: 0px;
        } 
    }
}
</style>